import React, { useState } from "react";
import { Form, Input, InputNumber, Button, Row, Col, notification } from "antd";
import {
  TagOutlined,
  EnvironmentOutlined,
  PhoneOutlined,
} from "@ant-design/icons";
import { addStateStudentCourseApi } from "../../../../api/stateStudentCourse";
import { getAccessToken } from "../../../../api/auth";
import { numberValidation } from "../../../../utils/formValidation";

import "./AddStateStudentCourseForm.scss";

export default function AddStateStudentCourseForm(props) {
  const { setIsVisibleModal, setReloadStateStudentCourses } = props;

  const [inputs, setInputs] = useState({
    statestudentcourse_code: "",
    description: "",
  });

  const [formValid, setFormValid] = useState({
    phone: false,
  });

  const inputValidation = (e) => {
    const { type, description } = e.target;

    setInputs({
      ...inputs,
      [description]: e.target.value,
    });
  };

  const isFormValid = (e) => {
    //console.log(inputs);
    let errorExists = false;
    if (!inputs.description) {
      notification["error"]({
        message: "Obligatorio: nombre.",
      });
      errorExists = true;
    }
    return errorExists;
  };

  const addStateStudentCourse = async (e) => {
    e.preventDefault();

    if (!isFormValid()) {
      const accessToken = getAccessToken();

      await addStateStudentCourseApi(accessToken, inputs)
        .then((response) => {
          if (
            response === "ERR_CONNECTION_REFUSED" ||
            response === "Failed to fetch" ||
            response === undefined
          ) {
            notification["error"]({
              message: "Servidor caido",
            });
          } else if (response.code !== 200) {
            notification["error"]({
              message: response.message,
            });
          } else {
            notification["success"]({
              message: "Estado creado",
            });
            setIsVisibleModal(false);
          }
          setReloadStateStudentCourses(true);
        })
        .catch((err) => {
          notification["error"]({
            message: err,
          });
        });
    }
  };

  return (
    <div className="add-statestudentcourse-form">
      <AddForm
        inputs={inputs}
        setInputs={setInputs}
        inputValidation={inputValidation}
        addStateStudentCourse={addStateStudentCourse}
      />
    </div>
  );
}

function AddForm(props) {
  const { inputs, setInputs, addStateStudentCourse, inputValidation } = props;

  return (
    <Form className="form-add" onSubmit={addStateStudentCourse}>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col span={12}>
          <label className="control-label">
            Código
          </label>
          <Form.Item>
            <InputNumber
              prefix={<TagOutlined />}
              placeholder="Automático"
              value={inputs.statestudentcourse_code}
              onChange={(e) => setInputs({ ...inputs, statestudentcourse_code: e })}
              style={{ width: "100%" }}
              disabled={true}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <label className="control-label">
            <span className="control-required">*</span> Descripción
          </label>
          <Form.Item>
            <Input
              placeholder="Descripción"
              value={inputs.description}
              onChange={(e) => setInputs({ ...inputs, description: e.target.value })}
            />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          className="btn-submit"
          onClick={addStateStudentCourse}
        >
          Crear
        </Button>
      </Form.Item>
    </Form>
  );
}
